// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import navigationBar from './components/common/navigationBar'
import myFooter from './components/common/FooterBar'
import pictures from './components/pictures'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.component('myNav', navigationBar)
Vue.component('myFooter', myFooter)
Vue.component('myPictures', pictures)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js